import React from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

const ScrollRevealSpan = ({ children, className }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    /* Optional options */
    threshold: 0,
  });

  return (
    <motion.span
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={className}
      ref={ref}
    >
      {children}
    </motion.span>
  );
};

export default ScrollRevealSpan;
